import React, { useEffect, useState, useRef, createRef } from 'react';
import PropTypes, { element } from 'prop-types';
import Backdrop from './../../../Components/CustomBackdrop/Barckdrop'
import FullScreenDialog from "./../../../PopUp/FullScreendialogs"
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import axios from 'axios'
import { genURL, gengetURLTEST } from "../../../_getjson.js";

export default function Payforservice(props) {
    const { parm } = props
    const [listitem, setListitem] = useState([])
    const Totaltax1 = useRef();
    const Vat = useRef();
    const [WHRow1, setWHRow1] = useState("");
    const [col2, setcol2] = useState("");
    const [openFullScreenDialog, setopenFullScreenDialog] = useState(false);
    const [titleFullScreenDialog, settitleFullScreenDialog] = useState("");
    const [typeFullScreenDialog, settypeFullScreenDialog] = useState("");
    const [dataMultipletax, setdataMultipletax] = useState("");
    const [rowid, setrowid] = useState("");
    const [refdocno, setrefdocno] = useState("");
    const [openBackdrop, setOpenBackdrop] = useState(false)
    useEffect(() => {
        componentdidmount()
    }, [])
    const componentdidmount = () => {
        console.log('payfirservice parm', parm);
        Totaltax1.current.value = parseFloat(parm.Totaltax1).toFixed(2)
        Vat.current.value = parseFloat(parm.Vat).toFixed(2)
        setrefdocno(parm.Refdocno)
        if (parm.payfirservice.length > 0) {
            setListitem(parm.payfirservice)

        } else {
            let item = []
            for (let index = 0; index < 15; index++) {
                item[index] = {
                    Taxinvoice: "",
                    Invoicedate: "",
                    PayableCode: "",
                    PayableName: '',
                    Taxdescription: "",
                    Amountbeforetax: "",
                    Tax: "",
                }
                setListitem(item)
            }
        }
    }
    const onRowClick = (data, col, id) => {
        setWHRow1(id);
        setcol2(false);
        if (col === 1) {
            if (!data.PayableCode) {
                listitem[id].Invoicedate = Moment(new Date()).format('YYYY-MM-DD')
                listitem[id].PayableCode = parm[0]
                listitem[id].PayableName = parm[1]
                listitem[id].Condition = '1'
            }
        }
        if (data.Taxinvoice) {
            setcol2(true);
            data.btn_C3 = 0
            data.btn_income = 0
            data.btn_type = 0
            data.btn_C4 = 0
            if (col === 2) {
                data.btn_income = 1
                data.Income = data.Incomecode
            }
            if (col === 6) {
                data.btn_C3 = 1
            }
            if (col === 14) {
                data.btn_type = 1
                data.Type = data.Typecode
            }
            if (col === 16) {
                data.btn_C4 = 1

            }
        } else {
            data.btn_C3 = 0
            data.btn_income = 0
            data.btn_type = 0
            data.btn_C4 = 0
            listitem[id].Condition = ''
        }

    }
    const onAfterSaveCell = (row, cellName, cellValue) => {
        for (let index = 0; index < listitem.length; index++) {
            if (listitem[index].Taxinvoice === "") {
                listitem[index].Invoicedate = ""
                listitem[index].PayableCode = ""
                listitem[index].PayableName = ""
                listitem[index].Tax = ""
            }
        }
        let id = row.numrow - 1
        if (cellName === 'Type' && row.Type) {
            var url = "CSWTAXTYPE/Search?Code=" + row.Type
            console.log(genURL(url));
            axios.get(genURL(url), { timeout: 60000 }).then(async (res) => {
                setOpenBackdrop(true)
                if (res.data.length > 0) {
                    for (var i = 0; i < res.data.length; i++) {
                        listitem[id].Typecode = await res.data[i].CODE
                        listitem[id].Type = await res.data[i].MYNAMETH
                    }
                } else {
                    listitem[id].Typecode = await ""
                    listitem[id].Type = await ""
                }
                setListitem([...listitem])
            }).finally(_ => {
                setOpenBackdrop(false)
            })
        }
        if (cellName === 'Income' && row.Income) {
            var url = "CSINCOMETYPE/Search?Code=" + row.Income
            console.log(genURL(url));
            axios.get(genURL(url), { timeout: 60000 }).then(async (res) => {
                setOpenBackdrop(true)
                if (res.data.length > 0) {
                    for (var i = 0; i < res.data.length; i++) {
                        listitem[id].Incomecode = await res.data[i].CODE
                        listitem[id].Income = await res.data[i].MYNAMETH
                        listitem[id].Taxdescription = await res.data[i].WTAXRATE
                    }
                } else {
                    listitem[id].Incomecode = await ""
                    listitem[id].Income = await ""
                    listitem[id].Taxdescription = await ""
                }
                setListitem([...listitem])
            }).finally(_ => {
                setOpenBackdrop(false)
            })
        }
        if (cellName === 'Amountbeforetax') {
            if (listitem[id].Taxinvoice) {
                console.log(cellValue);
                let res = (Number(listitem[id].Taxdescription) / 100) * Number(cellValue)
                console.log(res);
                row.Tax = parseFloat(res).toFixed(2)
            }
        }
        setTimeout(() => {
            SumCalculate(cellName)
        }, 50);
    }
    const onBeforeSaveCell = (row, cellName, cellValue) => {

    }
    const SumCalculate = (cellName) => {
        let sumTax = 0
        for (let index = 0; index < listitem.length && listitem[index].Taxinvoice; index++) {
            if (listitem[index].Tax !== "") {
                sumTax += Number(listitem[index].Tax)
            }
        }
        setTimeout(() => {
            if (sumTax > 0) {
                Totaltax1.current.value = parseFloat(sumTax).toFixed(2)
            }
        }, 50);
    }
    const onBlurAction = (e) => {
        if (e.target.value && e.target.type === "number") {
            e.target.value = parseFloat(e.target.value).toFixed(2)
        }
    }
    const Switch_OtherPopup1 = (type, row, dialog) => {
        setrowid(row)
        let pram = { type: type }
        setdataMultipletax(pram)
        setopenFullScreenDialog(true)
        settitleFullScreenDialog(dialog)
        settypeFullScreenDialog(type)
    };
    const CloseDialog = (e) => {
        setopenFullScreenDialog(e)
    }
    const ReturnData = (e) => {
        console.log(e);
        if (e) {
            let data = e[1].split('|')
            let id = rowid - 1
            if (typeFullScreenDialog === 'Incometype') {
                listitem[id].Incomecode = data[0]
                listitem[id].Income = data[1]
                listitem[id].Taxdescription = data[2]
            }
            if (typeFullScreenDialog === 'Apcode') {
                listitem[id].PayableCode = data[0]
                listitem[id].PayableName = data[1]
            }
            if (typeFullScreenDialog === 'taxtype') {
                listitem[id].Typecode = data[0]
                listitem[id].Type = data[1]
            }
            if (typeFullScreenDialog === 'Apcode1') {
                listitem[id].Actingonbehalf = data[0]
            }
        }
    }
    const Cleartable = () => {
        let item = []
        for (let index = 0; index < 15; index++) {
            item[index] = {
                Taxinvoice: "",
                Invoicedate: "",
                PayableCode: "",
                PayableName: '',
                Taxdescription: "",
                Amountbeforetax: "",
                Tax: "",
            }
            setListitem(item)
        }
        let resdata = {
            Totaltax1: 0,
            Vat: 0,
            sum: 0,
            listitem: item
        }
        props.sumdata('payfirservice', resdata)
    }
    const Getcsv_APPAYWTAX = async () => {
        await setOpenBackdrop(true)
        console.log(refdocno);
        var url = "CSV_APPAYWTAX/GET?Top=300&REFDOCNO=" + refdocno
        axios.get(genURL(url), { timeout: 60000 }).then(async (res) => {

            var row = []
            var sum = 0
            if (res.data.length > 0) {
                for (let i = 0; i < res.data.length; i++) {
                    sum = await (Number(res.data[i].AMOUNT) / 100) * Number(res.data[i].WTAXRATE)
                    row[i] = await {
                        Amount: res.data[i].AMOUNT,
                        Incometype: res.data[i].INCOMETYPE,
                        Itemtaxtype: res.data[i].ITEMTAXTYPE,
                        Payamount: res.data[i].AMOUNT,
                        Paybalance: res.data[i].PAYBALANCE,
                        Productcode: res.data[i].PRODUCTCODE,
                        Productname: res.data[i].PRODUCTNAME,
                        Refdocno: res.data[i].REFDOCNO,
                        Refdoctype: res.data[i].REFDOCTYPE,
                        Reflineid: res.data[i].REFLINEID,
                        Wtaxamount: res.data[i].WTAXAMOUNT,
                        Taxamount: (sum).toFixed(2),
                        Wtaxrate: res.data[i].WTAXRATE,
                    }
                }
                setListitem(row)
                let resdata = {
                    Totaltax1: "",
                    Vat: "",
                    sum: "",
                    listitem: row
                }
                props.sumdata('payfirservice', resdata)
            }
        }).finally(_ => {
            setOpenBackdrop(false)
        })
    }
    const Getcsv_APPAYWTAX1 = async () => {
        // console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx")
        var url = "CSV_APPAYWTAX/GETALL?Top=100&REFDOCNO=" + refdocno
        await setOpenBackdrop(true)
        axios.get(genURL(url), { timeout: 60000 }).then(async (res) => {

            var row = []
            var sum = 0

            // console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx", res.data)
            if (res.data.length > 0) {
                for (let i = 0; i < res.data.length; i++) {
                    sum = await (Number(res.data[i].AMOUNT) / 100) * Number(res.data[i].WTAXRATE)
                    row[i] = await {
                        Amount: res.data[i].AMOUNT,
                        Incometype: res.data[i].INCOMETYPE,
                        Itemtaxtype: res.data[i].ITEMTAXTYPE,
                        Payamount: res.data[i].AMOUNT,
                        Paybalance: res.data[i].PAYBALANCE,
                        Productcode: res.data[i].PRODUCTCODE,
                        Productname: res.data[i].PRODUCTNAME,
                        Refdocno: res.data[i].REFDOCNO,
                        Refdoctype: res.data[i].REFDOCTYPE,
                        Reflineid: res.data[i].REFLINEID,
                        Wtaxamount: res.data[i].WTAXAMOUNT,
                        Taxamount: (sum).toFixed(2),
                        Wtaxrate: res.data[i].WTAXRATE,
                    }
                }
                setListitem(row)
                let resdata = {
                    Totaltax1: "",
                    Vat: "",
                    sum: "",
                    listitem: row
                }
                props.sumdata('payfirservice', resdata)
            }
        }).finally(_ => {
            setOpenBackdrop(false)
        })
    }
    const SUMTotaltax = async (data) => {
        await setOpenBackdrop(true)
        console.log(data);
        var Totaltax = 0, vat = 0, sum = 0
        for (let i = 0; i < listitem.length && listitem[i].Productcode; i++) {
            Totaltax += Number(listitem[i].Paybalance)
            sum += Number(listitem[i].Taxamount)
        }

        vat = (Totaltax / 100) * 7
        Totaltax1.current.value = parseFloat(Totaltax).toFixed(2)
        Vat.current.value = parseFloat(vat).toFixed(2)
        let resdata = {
            Totaltax1: parseFloat(Totaltax).toFixed(2),
            Vat: parseFloat(vat).toFixed(2),
            sum: parseFloat(sum).toFixed(2),
            listitem: listitem
        }
        await props.sumdata('payfirservice', resdata)
        await setOpenBackdrop(false)
    }
    const indexN = (_0, _1, _2, index) => {
        return (<div>{index + 1}</div>)
    }
    const onclick = (e) => {
        if (e.target.value && e.target.type === "number") {
            e.target.value = Number(e.target.value); e.target.select()
        }
    }
    return (
        <div onBlur={e => onBlurAction(e)} onClick={onclick}>
            <Backdrop open={openBackdrop} />
            <FullScreenDialog open={openFullScreenDialog} title={titleFullScreenDialog} type={typeFullScreenDialog} parm={dataMultipletax}
                closeDialog={e => CloseDialog(e)}
                resData={e => ReturnData(e)}
            // type เป็นชื่อ Components subDialog ใช้เป็นเงือนไขในการเปิด subDialog
            />
            <BootstrapTable
                data={listitem}
                options={{
                    onRowClick: onRowClick,
                    noDataText: "ไม่พบข้อมูล"
                }}
                height='500'
                cellEdit={{ //แก้ไข
                    mode: 'click',
                    blurToSave: true,
                    beforeSaveCell: onBeforeSaveCell,//ก่อนเปลี่ยนค่า
                    afterSaveCell: onAfterSaveCell,//หลังเปลี่ยนค่า

                }} >
                <TableHeaderColumn dataAlign="center" width="45" dataField="any" dataFormat={indexN} ></TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="100" dataField='Productcode' editable={false} isKey> รหัสสิค้า/บริการ </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="100" dataField='Productname' editable={false} > ชื่อสินค้า/บริการ </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="100" dataField='Amount' editable={false} > จำนวนเงิน </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="100" dataField='Payamount' editable={false} > คงค้าง </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="100" dataField='Incometype' editable={false} > ประเภท </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="100" dataField='Wtaxrate' editable={false} > อัตรา </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="100" dataField='Paybalance' editable={false} > ยอดชำระ </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="100" dataField='Taxamount' editable={false} > ภาษีหัก ณ ที่จ่าย </TableHeaderColumn>
            </BootstrapTable>
            <div>
                <br></br>
                <Grid container spacing={3} direction="row">
                    <Grid item xs={8}>
                        <div> 1.กดเคลียร์รายการเดิม  <Button onClick={() => Cleartable()} variant="text">เคลียรายการเดิม</Button></div>
                        <div>2.กดแสดงสินค้า/บริการตามรายการ Invoice    <Button onClick={() => Getcsv_APPAYWTAX()} variant="text">แสดงสินค้า/บริการ</Button>
                            <Button onClick={() => Getcsv_APPAYWTAX1()} variant="text">แสดงสินค้า/บริการยอดเต็มบิล</Button>
                        </div>
                        <div>
                            3.ทุกครั้งที่แก้ไขยอดชำระให้กดปุ่ม <Button variant="text" onClick={() => SUMTotaltax()} >คำนวณภาษีหัก ณ ที่จ่ายและภาษีมูลค่าเพิ่ม</Button>
                        </div>

                    </Grid>

                    <Grid item xs={4}>
                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <span className="input-group-addon">รวมยอดชำระ </span>
                                <input type="number" className="form-control " ref={Totaltax1} name="Totaltax1" />
                            </div>
                        </div>
                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <span className="input-group-addon">ภาษีมูลค่าเพิ่ม </span>
                                <input type="number" className="form-control " ref={Vat} name="Vat" />
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </div>
        </div>

    )
}
Payforservice.prototype = {
    parm: PropTypes.array
}

